module.exports = __webpack_public_path__ + "static/img/item10.a95eb02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item10.png
// module id = oTzR
// module chunks = 1